"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ShortInfo_1 = __importDefault(require("../../../PostContentWrapper/ShortInfo"));
var BuildingProperties_1 = __importDefault(require("../BuildingProperties"));
var BuildingInfoSection = function (_a) {
    var postData = _a.postData;
    return (react_1.default.createElement("div", { className: "section-data" },
        react_1.default.createElement(ShortInfo_1.default, { postData: postData }),
        react_1.default.createElement(BuildingProperties_1.default, { aboutBuildings: postData.sections.about_building })));
};
exports.default = BuildingInfoSection;
